/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import moment from "moment";
import Loader from "../Loader";

interface EventItem {
  Event: string;
  Date: string;
  Reason?: string | null;
}

interface TestEmailReasonProps {
  reason?: string | null;
  isLoading?: boolean;
}


const TestEmailReason: React.FC<TestEmailReasonProps> = ({
  reason,
  isLoading = false,
}) => {
  let events: EventItem[] = [];

  if (!reason) {
    return (
      <p className="text-gray-600 text-center py-4">
        No event history available.
      </p>
    );
  }

  try {
    events = JSON.parse(reason);
  } catch (err) {
    console.error("Failed to parse eventHistory JSON:", err, reason);
    return (
      <p className="text-gray-600 text-center py-4">
        Invalid event history format.
      </p>
    );
  }

  if (isLoading) {
    return (
      <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/80 rounded-lg">
        <Loader />
      </div>
    );
  }

  return (
    <div className="relative px-[16px] pt-[10px]">
      <div className="relative min-h-[200px] mt-2">
        {events && events.length > 0 ? (
          events.map((item, index) => (
            <div
              key={index}
              className={`relative rounded-lg p-4 transition hover:shadow-lg bg-white border-gray-300 shadow-inner text-black mb-[5px]`}
            >
              <div className="flex justify-between items-start">
                <div>
                  {/* 🔹 Date prominently (larger font) */}
                  <h3
                    className="text-16 font-semibold text-muted mb-1"
                    style={{ color: "#3a3a3a" }}
                  >
                    {item.Event.charAt(0).toUpperCase() + item.Event.slice(1)}
                    
                  </h3>

                  {/* 🔹 Event smaller & normal-weight */}
                  <div
                    className="text-md font-normal mb-1 flex items-center gap-2"
                    style={{ color: "#3a3a3a" }}
                  >

                    <span>
                      {moment(item.Date, "YYYY-MM-DD HH:mm:ss").format(
                      "MMMM D YYYY, h:mm:ss A"
                    )}
                    </span>
                  </div>

                  {item.Reason && (
                    <div
                      className="text-md font-normal"
                      style={{ color: "#3a3a3a" }}
                    >
                      Reason: {item.Reason}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-600 text-center py-4">No events found.</p>
        )}
      </div>
    </div>
  );
};

export default TestEmailReason;
